import type { AcknowledgmentCommitmentItem } from '../model/types'

/**
 * The signer's first and last name for an action that re-sends the same signer. `changeSigner`
 * writes the name from these two fields, and a row may carry only `SignerName`: sending them empty
 * would erase the name, so the full name is split when the parts are missing.
 */
export const getSignerNameParts = (item: AcknowledgmentCommitmentItem) => {
  const firstName = item.SignerFirstName?.trim() ?? ''
  const lastName = item.SignerLastName?.trim() ?? ''

  if (firstName || lastName) {
    return { firstName, lastName }
  }

  const [first = '', ...rest] = (item.SignerName ?? '').trim().split(/\s+/)

  return { firstName: first, lastName: rest.join(' ') }
}
